import { Page } from '@/shared/ui/layout/page';

import { Onboarding } from './sign-up-page/onboarding';

export function SignUpPage() {
    return (
        <Page>
            <Onboarding />
        </Page>
    );
}
